.meter {
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
}

.header {
	display: flex;
	gap: 8px;
	align-items: baseline;
	justify-content: space-between;
}

.label {
	color: var(--content-tertiary);
}

.total {
	color: var(--content-primary);
}

.track {
	display: flex;
	gap: 3px;
	align-items: center;
	block-size: 8px;
	inline-size: 100%;
}

.slot {
	flex: 0 1 auto;
	block-size: 100%;
	min-inline-size: 4px;
}

.remainderSlot {
	flex: 1 1 0;
	min-inline-size: 0;
}

.track .trigger {
	display: flex;
	align-items: center;
	box-sizing: border-box;
	block-size: 24px;
	inline-size: 100%;
	margin-block: -8px;
	border-radius: 999px;
	padding-block: 8px;
}

.track .trigger:focus-visible .segment {
	outline: var(--focus-outline);
	outline-offset: 0;
}

.segment {
	box-sizing: border-box;
	block-size: 8px;
	inline-size: 100%;
	border-radius: 999px;
}

.remainder {
	background-color: var(--elevation-medium);
}

.chart1 {
	background-color: var(--chart-1);
}

.chart2 {
	background-color: var(--chart-2);
}

.chart3 {
	background-color: var(--chart-3);
}

.chart4 {
	background-color: var(--chart-4);
}

.chart5 {
	background-color: var(--chart-5);
}

.chart6 {
	background-color: var(--chart-6);
}

.chart7 {
	background-color: var(--chart-7);
}

.chart8 {
	background-color: var(--chart-8);
}

@media (prefers-reduced-motion: no-preference) {
	.segment {
		transition: inline-size 200ms ease-out;
	}
}

/* Forced colours drop every background, so outline each pill to keep the split perceivable. */
@media (forced-colors: active) {
	.segment {
		border: 1px solid CanvasText;
	}
}
